<app-catalog-table
  [data]="data()"
  [columns]="columns"
  [meta]="meta()"
  [loading]="loading()"
  [userManual]="pricesUserManual"
  [actions]="tableActions()"
  [showAdd]="canAdd()"
  [initialFilters]="restoredFilters()"
  (onPage)="onPageChange($event)"
  (onFilter)="onFilterChange($event)"
  (onSort)="onSortChange($event)"
  (onRefresh)="onRefresh()"
  (onReset)="onReset()"
  (onAdd)="handleAdd()"
  (onEdit)="handleEdit($event)"
  (onCustomAction)="handleCustomAction($event)"
/>

<p-toast position="bottom-right" />
<p-confirmDialog />
